<template>
  <div class="abs-center-box logo-img-box" v-show="show">
    <img :src="logoUrl" ondragstart="return false;"/>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    show: {
      type: Boolean,
      default: true
    },
    logoUrl: {
      type: String,
      default: require("@/assets/img/platform_logo.png")
    }
  }
};
</script>

<style lang="scss" scoped>
.logo-img-box {
  width: 3.05rem;
  height: 2.24rem;
  display: block;
  transform: translate(-50%, -50%);
  img {
    width: 100%;
    height: 100%;
  }
}
@media all and (orientation: portrait) {
 .logo-img-box{
   transform: translate(-50%, -50%) rotate(90deg);;
  }
}
</style>